import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./styles.module.scss";
import { Breadcrumb, Container } from "react-bootstrap";
import { getRoute } from "@/functions/getRoute";

export const BreadcrumbNavigation = ({ className, items }) => {
  return (
    <div className={cn(className, styles.breadcrumbs)}>
      <Container className="mw-xxl">
        <Breadcrumb>
          <Breadcrumb.Item href={getRoute("home")}>Global Medics</Breadcrumb.Item>
          {items.map(({ label, href }, k) => (
            <Breadcrumb.Item key={k} href={href}>
              <svg width="6" height="8" viewBox="0 0 6 8" fill="#F25A18" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4L0 -2.62268e-07L-3.49691e-07 8L6 4Z" />
              </svg>
              {label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </Container>
    </div>
  );
};

export default BreadcrumbNavigation;
